export default {
	closeLabel: 'Close navigation menu',
	openLabel: 'Open navigation menu',
};
